import React from 'react';
import { string, func, oneOfType, bool } from 'prop-types';
import { t } from 'i18next';
import { informationCircleOutline } from 'ionicons/icons';

import SearchAddressMap from '../SearchAddressMap';
import { DEFAULT_MAX_RESULTS } from '../../constants';
import styles from '../../styles.module.scss';

import WarningMessage from '~components/WarningMessage';
import StoreSearchBar from '~components/StoreSearchBar';
import { googleAddressPropTypes } from '~propTypes/address';
import CustomButton from '~components/CustomButton';

function AddressConfirm({
  selectedAddress,
  onAddressSelect,
  onSearchInputChange,
  incompleteAddress,
  isConfirmAddress,
  onMarkerDragEnd,
  onConfirmAddress
}) {
  return (
    <>
      {selectedAddress ? null : (
        <WarningMessage
          text={
            <div className={styles.warningMessage}>
              <span className="m-bottom-1">{t('ChangeAddress:enterYourAddressAsFollow')}</span>
              <span>{t('ChangeAddress:addressFormat')}</span>
            </div>
          }
          icon={informationCircleOutline}
          typeWarning="purple"
          classes={`m-top-1 m-bottom-3 ${styles.warningMessageContainer}`}
          fontClass="papa-sans-bold"
        />
      )}
      <div className={`full-width m-bottom-1 ${styles.searchBarContainer}`}>
        <StoreSearchBar
          key="modalSearchBar"
          maxResults={DEFAULT_MAX_RESULTS}
          selectedAddress={selectedAddress}
          onAddressSelect={onAddressSelect}
          onChange={onSearchInputChange}
          onClean={onSearchInputChange}
          incompleteAddress={incompleteAddress}
        />
      </div>
      {selectedAddress ? (
        <>
          <WarningMessage
            text={t('ChangeAddress:moveThePin')}
            icon={informationCircleOutline}
            typeWarning="purple"
            classes={`m-bottom-3 ${styles.warningMessageContainer}`}
            fontClass={styles.warningMessage}
          />
          <div className="full-width m-bottom-6">
            <SearchAddressMap currentAddress={selectedAddress} onMarkerDragEnd={onMarkerDragEnd} />
          </div>
        </>
      ) : null}
      {!isConfirmAddress && selectedAddress && (
        <CustomButton type="button" fullWidth fab btnClassType="primary" onClick={onConfirmAddress}>
          {t('ChangeAddress:addressConfirmMessage')}
        </CustomButton>
      )}
    </>
  );
}

AddressConfirm.propTypes = {
  onAddressSelect: func.isRequired,
  incompleteAddress: oneOfType([string, undefined]),
  isConfirmAddress: bool,
  selectedAddress: googleAddressPropTypes,
  onConfirmAddress: func,
  onMarkerDragEnd: func,
  onSearchInputChange: func
};

export default AddressConfirm;
